import React, { useState } from 'react';
import { TextField, Button, MenuItem, Box, Typography, CircularProgress } from '@mui/material';
import { Image } from 'primereact/image';
import { FiUploadCloud } from "react-icons/fi";

import banner from "../../assets/images/banner-b.jpg";
import { EmailService } from '../../services/email';
import { toast } from 'react-toastify';
import PhoneNumberInput from '../../components/inputPhoneNumber';

const ufOptions = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];

const prestadorOptions = [
    "Associação Médica",
    "Consultório Médico",
    "Clínica",
    "Cooperativa",
    "Fornecedor",
    "Home Care",
    "Hospital Dia",
    "Hospital Especializado",
    "Hospital Geral",
    "Laboratório",
    "Maternidade",
    "Policlínica",
    "Pronto Socorro",
    "Pronto Socorro Especializado",
    "Remoção",
    "Serviço de Imagem",
    "Teleconsulta",
    "Terapias Não Médicas"
];

const FormCredenciado: React.FC = () => {

  const instance = new EmailService();
  
  const [disabled, setDisabled] = useState<boolean>(false);
  
  const [formData, setFormData] = useState({
    cnpjCpf: '',
    nome: '',
    telefone: '',
    whatsapp: '',
    email: '',
    endereco: '',
    numero: '',
    bairro: '',
    cidade: '',
    uf: '',
    tipoPrestador: '',
    especialidades: '',
    comentario: '',
    arquivo: null as File | null,
  });  

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, files } = e.target;
    if (name === 'arquivo' && files ) {
      setFormData({ ...formData, arquivo: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setFormData({ ...formData, arquivo: event.target.files[0] });
    }
  };
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setDisabled(true);

    sendMensagem();
    
  };

  // telefone input 
  const [phone, setPhone] = useState({ masked: "", unmasked: "" });

  const handlePhoneChange = (maskedValue: string, unmaskedValue: string, name: string) => {
    setPhone({ masked: maskedValue, unmasked: unmaskedValue });

    setFormData({ ...formData, [name]: maskedValue });
  };
  
  const sendMensagem = () => {

    instance
    .send_email_credenciado(formData)
    .then(res => {
      clear(); 
    })
    .catch(error => {
      console.log('error', error);
      setDisabled(false);
    });

  }

  const clear = () => {
    setFormData(
      {
        cnpjCpf: '',
        nome: '',
        telefone: '',
        whatsapp: '',
        email: '',
        endereco: '',
        numero: '',
        bairro: '',
        cidade: '',
        uf: '',
        tipoPrestador: '',
        especialidades: '',
        comentario: '',
        arquivo: null as File | null,
      }
    );
    toast.success('Formulário enviado com sucesso!');
    setDisabled(false);
  }
  return (
    <Box>
        <Image src={banner} width='100%'/>
        <Box sx={{ maxWidth: 700, mx: 'auto', mt: 2, mb: 2, backgroundColor: "#f9f9f9", borderRadius: "1em", padding: "1em" }}>
        <Typography variant="h4" component="h1" gutterBottom color='#4d4d4d'>
          Preencha o formulário que retornaremos.
        </Typography>
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                  size='small'
                  label="CNPJ / CPF"
                  name="cnpjCpf"
                  value={formData.cnpjCpf}
                  onChange={handleChange}
                  fullWidth
                  margin="normal"
              />
              <TextField
                  size='small'
                  label="Nome"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  fullWidth
                  margin="normal"
              />

          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
              <PhoneNumberInput
                value={formData.telefone}
                onChange={handlePhoneChange}
                name="telefone"
                label='Telefone'
              />
               <PhoneNumberInput
                value={formData.whatsapp}
                onChange={handlePhoneChange}
                name="whatsapp"
                label='Whatsapp'
              />
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                  size='small'
                  label="E-mail"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  fullWidth
                  margin="normal"
              />
              <TextField
                  size='small'
                  label="Endereço"
                  name="endereco"
                  value={formData.endereco}
                  onChange={handleChange}
                  fullWidth
                  margin="normal"
              />
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
                  size='small'
                  label="Número"
                  name="numero"
                  value={formData.numero}
                  onChange={handleChange}
                  fullWidth
                  margin="normal"
            />
            <TextField
                  size='small'
                  label="Bairro"
                  name="bairro"
                  value={formData.bairro}
                  onChange={handleChange}
                  fullWidth
                  margin="normal"
            />
              <TextField
                  size='small'
                  label="Cidade"
                  name="cidade"
                  value={formData.cidade}
                  onChange={handleChange}
                  fullWidth
                  margin="normal"
              />
              <TextField
                  size='small'
                  select
                  label="UF"
                  name="uf"
                  value={formData.uf}
                  onChange={handleChange}
                  fullWidth
                  margin="normal"
              >
              {ufOptions.map((uf) => (
                <MenuItem key={uf} value={uf}>
                  {uf}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
          </Box>
          <TextField
              select
              label="Tipo de Prestador"
              name="tipoPrestador"
              value={formData.tipoPrestador}
              onChange={handleChange}
              fullWidth
              margin="normal"
              >
              {prestadorOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                  {option}
                  </MenuItem>
              ))}
          </TextField>

          <TextField
              size='small'
            label="Especialidades / Serviços realizados"
            name="especialidades"
            value={formData.especialidades}
            onChange={handleChange}
            fullWidth
            multiline
            rows={3}
            margin="normal"
          />
          <TextField
              size='small'
            label="Comentário"
            name="comentario"
            value={formData.comentario}
            onChange={handleChange}
            fullWidth
            multiline
            rows={3}
            margin="normal"
          />
             <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              margin: '20px 0',
            }}
          >
            <Button
              variant="outlined"
              component="label"
              color="primary"
              
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                padding: '10px 20px',
                border: `2px dashed ${formData.arquivo ? 'green' : "#004387"}`,
                color: formData.arquivo ? 'green' : "#004387",
                fontWeight: 'bold',
              }}
            >
              <FiUploadCloud /> Enviar Portfólio
              <input hidden accept=".pdf" multiple type="file" onChange={handleFileChange}/>
            </Button>
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ textAlign: 'center', fontSize: '0.875rem' }}
            >
              Permitido apenas arquivos PDF com tamanho máximo somado de 25 MB.
            </Typography>
          </Box>

          <Button 
            type="submit" 
            variant="contained" 
            color="warning" 
            fullWidth
            disabled={disabled}
          > {disabled ? <CircularProgress size={24} color="inherit" /> : '✓ Enviar E-mail'} </Button>
       
        </form>
      </Box>
    </Box>
  );
};

export default FormCredenciado;
